import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import Milestones from "./components/Milestones";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import Bookking from "./components/Bookking";
import ChooseUs from "./components/ChooseUs";
import Testimonial from "./components/Testimonial";
import Playstore from "./components/Playstore";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Banner />
      <Milestones />
      <AboutUs />
      <Services />
      <Bookking />
      <ChooseUs />
      <Testimonial />
      <Playstore />
      <Footer />
    </div>
  );
}

export default App;
